import {createRouter, createWebHistory} from "vue-router";
import util from '@/libs/util.js'

const routes = [
    {
        path: "/",
        redirect: "/es",
    },
    {
        path: "/pm",
        children: [
            {
                path: "list",
                name: "pmList",
                meta: {title: '项目列表'},
                component: () => import("../views/pss/pm/list")
            },
            {
                path: "detail",
                name: "pmDetail",
                meta: {title: '项目进度管理'},
                component: () => import("../views/pss/pm/detail")
            }
        ]
    },
    {
        path: "/es",
        name: "externalSelection",
        meta: {title: '外部选择器'},
        component: () => import("../views/pss/es/externalSelection")
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes: routes
})

router.afterEach(to => {
    util.title(to.meta.title)
})

export default router;
